export enum XmlElementType {
	RootElement,
	Element,
	Attribute,
}
